// src/app/shared/directives/alpha-num-slash.directive.ts
import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appAlphaNumSlash]',
  standalone: true 
})
export class AlphaNumSlashDirective {
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const allowedPattern = /^[a-zA-Z0-9/]$/;
    const inputChar = String.fromCharCode(event.keyCode || event.which);

    if (!allowedPattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
